import { render, staticRenderFns } from "./wizard-step4.vue?vue&type=template&id=7f50e9b0&scoped=true&"
import script from "./wizard-step4.vue?vue&type=script&lang=js&"
export * from "./wizard-step4.vue?vue&type=script&lang=js&"
import style0 from "./wizard-step4.vue?vue&type=style&index=0&id=7f50e9b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f50e9b0",
  null
  
)

export default component.exports